"use server";

import { decide } from "@/modules/access";
import { getCommunication } from "@/modules/contacts";
import { personReach } from "@/modules/contact-records";
import { getActor } from "@/modules/access/api/actor/get-provider-timeline";

/** The name, email, numbers and default address of a person contact, by field name (`name`, `email`, `phone`, `mobile`, `whatsapp`, `street`, `street2`, `city`, `state`, `postalCode`, `country`) and the `language` of their emails (empty when none), for a form to fill when a contact is picked. Only for staff who may read Contacts; empty when there is no such contact. */
export async function readContactReachAction(contactId: string): Promise<Record<string, string>> {
  const actor = await getActor();
  if (!actor || !decide(actor.grants, "contacts", "read").allowed) return {};
  const [reach, communication] = await Promise.all([personReach(contactId), getCommunication(contactId)]);
  if (!reach) return {};
  const { address, ...rest } = reach;
  return { ...rest, ...address, language: communication?.emailLanguage ?? "" };
}
